module.exports = __webpack_public_path__ + "img/lead-islands.3fe1db74.svg";